export const LOCAL_STORAGE_PREFIX = '___yohrsApplication___'
